export function ensureUrlProtocol(url: string): string {
    if (!url || typeof url !== "string") return url;
    const trimmed = url.trim();
    if (
      trimmed.startsWith("http://") ||
      trimmed.startsWith("https://")
    ) {
      return trimmed;
    }
    return `https://${trimmed}`;
  }

export function fileNameFromUrl(url: string): string {
    try {
        const pathname = new URL(url).pathname;
        const segment = pathname.split("/").filter(Boolean).pop();
        return segment ? decodeURIComponent(segment) : "";
    } catch {
        const segment = url.split("/").filter(Boolean).pop();
        return segment ? decodeURIComponent(segment) : "";
    }
}

/** Downloads via fetch when CORS allows; otherwise uses a direct link like the CSV template (new tab if preview only). */
export async function downloadFileFromUrl(
    url: string,
    filename?: string,
): Promise<void> {
    if (!url?.trim()) return;
    const name = filename || fileNameFromUrl(url) || "download";
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.statusText);
        const blob = await res.blob();
        const objUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objUrl;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(objUrl);
    } catch {
        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
}

/** Detects PDFs from URL path (handles query strings and malformed URLs). */
export function isPdfUrl(url: string | null | undefined): boolean {
    if (!url || typeof url !== "string") return false;
    const trimmed = url.trim();
    if (!trimmed) return false;
    try {
        const { pathname } = new URL(trimmed);
        return /\.pdf$/i.test(pathname);
    } catch {
        const pathOnly = trimmed.split(/[?#]/)[0] ?? "";
        return /\.pdf$/i.test(pathOnly);
    }
}
